import ResultData from '../enums/ResultData.js';

const filterWithDateBetween = function(dateFrom, dateTo) {
    if (dateFrom && dateTo) {
        return [ { parameter: [ResultData.CreateDate.key], operator: 'BETWEEN', value: [dateFrom, dateTo]}];
    }
    if (dateFrom) {
        return [ { parameter: [ResultData.CreateDate.key], operator: '>=', value: dateFrom}];
    }
    if (dateTo) {
        return [ { parameter: [ResultData.CreateDate.key], operator: '<=', value: dateTo}];
    }

    return [];
};

const filterExactDate = function(date) {
    // todo

    return [];
};

export {
    filterWithDateBetween, filterExactDate,
};